import { render, staticRenderFns } from "./bonus.vue?vue&type=template&id=008b692c&"
import script from "./bonus.vue?vue&type=script&lang=ts&"
export * from "./bonus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports